import { BadgeTypes } from '@/components';
import { ReactElement } from 'react';

export interface Information {
	title: string;
	content: string | ReactElement;
}

export const FAQS: Information[] = [
	{
		title: 'Who is behind Claim Magic?',
		content:
			"Claim Magic is powered by Lowey Dannenberg P.C., a top-tier law firm with over 50 years of experience winning major cases and recovering billions for people like you. Once you register, we'll connect you with an experienced attorney from our team to make sure you get the expert help you need.",
	},
	{
		title: 'Why do I need to sign up?',
		content:
			'Signing up lets you manage your claim all in one place. You can securely upload documents, message your legal team, track progress, and get paid—right from your phone or computer. No paperwork, no hassle.',
	},
	{
		title: 'How can I get updates on my case?',
		content:
			'You can follow every step of your case on the Claim Magic platform. From filing to resolution, you’ll see exactly where things stand and can message your lawyer any time.',
	},
	{
		title: 'How do I get paid?',
		content:
			'When your claim is resolved, we will electronically send payment directly to your account. No waiting for checks in the mail.',
	},
	{
		title: 'How do I begin?',
		content:
			'It’s easy! Just go to the Explore Cases page, select an open case, and apply to see if you qualify—it’s free and takes less than 5 minutes. Our lawyers will evaluate your claim and notify you of your eligibility.',
	},
	{
		title: 'Can I communicate directly with my attorney through your platform?',
		content:
			'Yes, you can communicate directly with your attorney through our platform.',
	},
	{
		title: 'How long does it take to resolve a claim?',
		content:
			'The time to resolve a case can vary depending on the nature of the claims and the parties involved. Generally, it takes about 2-3 years for cases to be resolved entirely.',
	},
	{
		title: 'How do your fees work?',
		content:
			'You pay nothing upfront or if we lose your case. If your claim is successful, our fees will be a percentage of the settlement or recovery we obtain on your behalf.',
	},
	{
		title: 'Is my information secure on your platform?',
		content:
			'Yes, we take your privacy and security seriously. Your information is kept strictly confidential, and we never sell or share it without your consent. We also employ advanced encryption and take steps to secure our servers to protect your data.',
	},
	{
		title: 'What is arbitration?',
		content:
			'Arbitration is an alternative dispute resolution process where two parties agree to resolve their dispute outside of court. It is generally faster and more cost-effective than traditional litigation, with a neutral third party, such as a former judge or an experienced lawyer, serving as the arbitrator. The arbitrator listens to both sides, reviews evidence, and makes a binding decision, which can often be less formal but still legally enforceable. Arbitration is commonly used in contracts to avoid lengthy legal proceedings.',
	},
	{
		title: 'What is a class action?',
		content:
			'A class action is a type of lawsuit where one or more plaintiffs, known as class representatives, bring a case on behalf of a larger group of individuals who have similar claims. These individuals, known as the "class," are typically affected by the same issue, such as defective products, corporate misconduct, or consumer fraud. Class actions allow all claims to be resolved collectively, which can make it more efficient and cost-effective than handling each case individually. Any settlement or judgment typically applies to all members of the class.',
	},
	{
		title: 'How is arbitration different from a class action?',
		content:
			'Arbitration is an individual process where a single person’s claims are resolved outside of court, typically through a neutral arbitrator. In contrast, a class action involves a group of people with similar claims, represented by a plaintiff who must meet specific qualifications to act on behalf of the entire group. Class actions are handled in court and aim to address the common interests of all class members collectively.',
	},
];

interface HowWorks {
	number: number;
	title: string;
	image: string;
	description: string;
	side: 'left' | 'right';
	color: string;
	logos?: string[];
	sizeLogo?: string;
	smallText?: string;
}

export const HOW_WORKS: HowWorks[] = [
	{
		number: 1,
		title: 'Check if Your Claims Qualify',
		description: 'Find out if you qualify for free with 5 questions or less.',
		image: '/img/landing/device-1.png',
		side: 'right',
		color: '#8039DF',
		logos: ['/img/landing/lowey-dannenberg-logo.png'],
		sizeLogo: 'min-w-12 h-12',
		smallText:
			'Claim Magic is backed by Lowey Dannenberg P.C., a law firms with more than 50 years of landmark results.',
	},
	{
		number: 2,
		title: 'Match with an Expert Attorney',
		description:
			'Claim Magic pairs you with an attorney from Lowey Dannenberg, a nationally recognized firm with decades of experience handling claims like yours.',
		image: '/img/landing/device-2.png',
		side: 'left',
		color: '#4639DF',
		logos: [
			'/img/landing/super-lawyers.png',
			'/img/landing/av-preeminent-logo.png',
		],
		sizeLogo: 'w-[128px] h-8',
	},
	{
		number: 3,
		title: 'Maximize your Recovery',
		description:
			'Manage your claim from our user-friendly platform – conveniently contact your lawyers, upload documents, and receive payments all in one place.',
		image: '/img/landing/device-3.png',
		side: 'right',
		color: '#89A8F0',
	},
];

export const CASES = [
	{
		type: 'whistleblower' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'commodities' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'health_care' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'securities' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'antitrust' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'commercial' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'whistleblower' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'securities' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
	{
		type: 'commodities' as BadgeTypes,
		title: 'Investigating Nike’s Shady Business',
		subtitle: 'Eligibility Criteria: ',
		description:
			'Purchased NIKE, Inc. Class B common stock between March 19, 2021, and March 21, 2024.',
	},
];
